<template>
  <div class="links d-flex text-center">
    <a
      class="flex-fill bg-facebook text-white p-1 px-3"
      :href="'https://www.facebook.com/sharer/sharer.php?u='+itemUrl"
      target="_blank"
    >
      <i class="fab fa-facebook"></i>
    </a>
    <a
      class="flex-fill bg-twitter text-white p-1 px-3"
      :href="'http://www.twitter.com/share?url='+itemUrl"
      target="_blank"
    >
      <i class="fab fa-twitter"></i>
    </a>
    <a
      class="flex-fill bg-dark text-white p-1 px-3"
      :href="'mailto:?subject='+rawMenu.user.name+' Menu - '+item.name+'&body='+item.description+' '+itemUrl"
      target="_blank"
    >
      <i class="fal fa-envelope-open-text"></i>
    </a>
    <a
      class="flex-fill bg-pinterest text-white p-1 px-3"
      :href="'http://pinterest.com/pin/create/button/?url='+itemUrl+'&description='+item.description"
      target="_blank"
    >
      <i class="fab fa-pinterest"></i>
    </a>
  </div>
</template>

<style scoped>
.links a {
  font-size: 1.2rem;
  color: #fff;
}
</style>

<script>
export default {
  computed: {
    itemUrl: function () {
      return (
        "https://www.happymenu.co/" +
        this.$route.params.userSlug +
        "/menu/" +
        this.$route.params.categorySlug +
        "/" +
        this.$route.params.itemSlug
      );
    },
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
